<template>
  <div class="metafield-edit-relation">
    <p class="metafield__title">{{ field.label }}</p>

    <ProductSearch
      v-if="isVariant"
      v-model="selectedProduct"
      :items="checkboxProducts"
      :loading="showLoader"
      title="Select product"
      @input="handleSelectProductForVariants"

      :key_uid="keyUid"
      key_img="image"
      key_img_second="src"
      key_label="title"
    ></ProductSearch>

    <RelationSetter
      v-if="subFormData.relateTo !== 'variant' || relationProducts"
      :loading="showLoader"
      :items="relationProducts"
      :value="mappedValue"
      :unselectedLabel="unselectedLabel"
      :selectedLabel="selectedLabel"
      @input="handleRelationSet"

      :key_uid="keyUid"
      key_img="image"
      key_img_second="src"
      key_label="title"
    ></RelationSetter>

    <TypographyInputHint v-if="hint">{{ hint }}</TypographyInputHint>
  </div>
</template>

<script>
import RelationSetter from '@/components/RelationSetter'
import ProductSearch from '@/components/ProductSearch'
import { mapGetters } from 'vuex'
import { forSingleMetafield } from '@/mixins/metafields-changed-detection.mixin'

export default {
  mixins: [ forSingleMetafield(true) ],
  components: {
    RelationSetter,
    ProductSearch
  },
  props: {
    field: Object,
    value: { type: [ Object, Array ]},
    hint: String,
    subFormData: Object
  },
  data () {
    return {
      selectedProduct: null,
      checkboxProducts: null,
      loading: true,
      relationProducts: null,
      groupKey: null,
      variantValue: {
        productId: null,
        productHandle: null,
        variants: null
      },
      endpoint: null
    }
  },
  computed: {
    ...mapGetters('cacheMetafields', [
      'cachedRelations',
      'isRequestPending',
    ]),
    keyUid() {
      return (this.isVariant) ? 'id' : 'handle';
    },
    isVariant () {
      return this.subFormData.relateTo === 'variant'
    },
    mappedValue () {
      if (this.isVariant) {
        return (this.value) ? this.value.variants : null
      } else {
        return this.value
      }
    },
    unselectedLabel () { 
      return `Select ${this.subFormData.relateTo}s` 
    },
    selectedLabel () { 
      return `Selected ${this.subFormData.relateTo}s` 
    },
    showLoader () {
      return this.isRequestPending[this.endpoint] || this.loading
    }
  },
  watch: {
    cachedRelations: {
      handler () {
        this.prepareProducts()
      },
      deep: true
    }
  },
  methods: {
    handleRelationSet (val) {
      if (!this.isVariant) {
        this.$emit('input', val)
      } else {
        this.variantValue.variants = val
        this.$emit('input', this.variantValue)
      }
    },
    async handleSelectProductForVariants (val, isInitLoad) {
      this.variantValue.productId = val
      this.loading = true
      const { product } = await this.$store.dispatch(`shopifyApi/REQUEST`, { 
          endpoint: `item/product/${val}/variants`
      })
      this.loading = false
      this.variantValue.productHandle = product.handle
      this.relationProducts = product.variants

      if (!isInitLoad) {
        // Reset relation setter value after checking different product for variants
        this.variantValue.variants = []
        this.$emit('input', this.variantValue)
      }
    },
    async prepareVariants () {
      if (!this.relationProducts || !this.relationProducts.length) {
        try {

          if (this.isVariant) {
            if (this.value && this.value.productId) {
              this.selectedProduct = this.value.productId
              await this.handleSelectProductForVariants(this.selectedProduct, true)
            }
          }

        } catch (error) {
          console.error(error)
        } finally {
          this.loading = false
        }
      }   
    },
    prepareProducts () {
      if (this.cachedRelations && this.cachedRelations[this.endpoint]) {

        if (this.isVariant) {
          this.checkboxProducts = this.cachedRelations[this.endpoint]
        } else {
          this.relationProducts = this.cachedRelations[this.endpoint]
        }
        this.loading = false
      }
    }
  },
  created () {
    this.endpoint = (this.isVariant) ? 'product' : this.subFormData.relateTo
    this.prepareProducts() // immediate on watch doesnt worked.
    this.prepareVariants()
  }
}
</script>

<style lang="scss">
  @import './src/assets/styles/mixins.scss';

  .metafield-edit-relation {
    display: block;

    .metafield__title {
      margin-bottom: 20px;
    }

    .TypographyInputHint {
      margin-top: 13px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/metafields-edit/metafields/MetafieldEditRelation.vue